module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-9.42646f5.woff2";